import { useMediaQuery } from '@/hooks/useMediaQuery';
import { MobileLayout } from './MobileLayout';
import { DesktopLayout } from './DesktopLayout';
import { LoadingLine } from '@/components/ui/LoadingLine';

/**
 * Responsive layout that switches between mobile and desktop views
 */
export function ResponsiveLayout() {
  const isDesktop = useMediaQuery('(min-width: 800px)');

  return (
    <>
      <LoadingLine />
      {isDesktop ? <DesktopLayout /> : <MobileLayout />}
    </>
  );
}
